module.exports = __webpack_public_path__ + "static/media/L.3ba85a37.png";